<template>
    <ul class="breadcrumbs">
        <li v-for="(breadcrumb, i) in list" :key="i">
            <span v-if="i !== 0" class="divider">
                <font-awesome-icon :icon="['fal', 'chevron-double-right']"/>
            </span>
            <router-link v-if="breadcrumb.link" :to="breadcrumb.link">
                {{ breadcrumb.name }}
            </router-link>
            <template v-else>
                {{ breadcrumb.name }}
            </template>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "bread-crumbs",
        props: {
          list: Array
        }
    }
</script>

<style scoped>
    ul {
        display: flex;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    ul > li {
        display: flex;
        width: auto;
        font-size: 1rem;
        color: #616161;
        cursor: default;
        line-height: 1.5;
    }

    ul > li > .divider {
        padding: 0 .5rem;
        font-size: 0.7rem;
        line-height: 1.5rem;
    }

    ul > li > .divider .svg-inline--fa {
        vertical-align: middle;
    }

    ul > li > a {
        color: #f96e46;
    }
</style>
